export class ComparabilityModalPayload {
  transactionIdentifier: string;
  transactionComparabilityId: number;
}
